import { Card } from "@/components/ui/card";
import CardIcon from "@/assets/icons/CardIcon.tsx";
import PixIcon from "@/assets/icons/PixIcon.tsx";
import ConvertIcon from "@/assets/icons/ConvertIcon.tsx";
import RefoundIcon from "@/assets/icons/RefoundIcon.tsx";
import BlockIcon from "@/assets/icons/BlockIcon.tsx";
import { Skeleton } from "@/components/ui/skeleton";
import { useTranslation } from "react-i18next";

interface MetricsCardProps {
  metrics: {
    card_approval_rate: {
      value: number;
      unit: string;
    };
    pix_conversion: {
      value: number;
      unit: string;
    };
    local_payments_conversion: {
      value: number;
      unit: string;
    };
    refunds: {
      value: number;
      unit: string;
    };
    chargebacks: {
      value: number;
      unit: string;
    };
  };
  isLoadingData: boolean;
}

export default function MetricsCard({
  metrics,
  isLoadingData,
}: MetricsCardProps) {
  const { t } = useTranslation("dashboard");

  return (
    <Card className="border-[#27272A] rounded-lg">
      <div className="border-b border-[#27272A]">
        <h2 className="text-lg font-semibold text-white p-4 mb-1">
          {t("metrics.title")}
        </h2>
      </div>
      <div className="space-y-4 p-4">
        {[
          {
            icon: <CardIcon />,
            label: t("metrics.cardApproval"),
            value: metrics?.card_approval_rate?.value,
            unit: metrics?.card_approval_rate?.unit,
          },
          {
            icon: <PixIcon />,
            label: t("metrics.pixConversion"),
            value: metrics?.pix_conversion?.value,
            unit: metrics?.pix_conversion?.unit,
          },
          {
            icon: <ConvertIcon />,
            label: t("metrics.localPayments"),
            value: metrics?.local_payments_conversion?.value,
            unit: metrics?.local_payments_conversion?.unit,
          },
          {
            icon: <RefoundIcon />,
            label: t("metrics.refunds"),
            value: metrics?.refunds?.value,
            unit: metrics?.refunds?.unit,
          },
          {
            icon: <BlockIcon />,
            label: t("metrics.chargebacks"),
            value: metrics?.chargebacks?.value,
            unit: metrics?.chargebacks?.unit,
          },        
        ]
          .filter(Boolean)
          .map((metric, index) => (
          <div key={index} className="flex items-center justify-between pt-4">
            <div className="flex items-start gap-4">
              {metric.icon}
              <div className="flex flex-col items-start gap-1">
                <span className="text-[#A1A1AA] text-xs">{metric.label}</span>
                {isLoadingData ? (
                  <Skeleton className="w-16 h-6 rounded-md" />
                ) : (
                  <span className="text-white font-medium text-lg">
                    {metric.value}
                    {metric.unit === "%" ? "%" : ""}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
